/* Se importan las paginas que se pueden navegar */
import Landing from "@/shared/pages/Landing.vue";
import LandingESign from "@/esign/pages/LandingESign.vue";
import About from "@/shared/pages/About.vue";
import ErrAuth from "@/shared/pages/ErrAuth.vue";

const routes = [
    { path: "/landing", name: "landing", component: Landing, meta: { auth: true } },
    { path: "/LandingESign", name: "LandingESign", component: LandingESign, meta: { auth: true, role: 'View_ESignArea/ESign/Index,ADMIN,View_TetrisESignArea/TetrisESign/Index,JLLT_VIEW,HR_ADMIN' } },
    { path: "/about", name: "about", component: About, meta: { auth: true }},
    {
        path: "/admin/Approvers",
        name: "Approvers",
        component: () => import(/* webpackPrefetch: true */ "@/esign/pages/LandingESignApprovers.vue"),
        meta: { auth: true, role: 'R_ESIGN_ADMIN,R_TETRIS_ESIGN_ADMIN,ADMIN' }
    },
    {
        path: "/admin/Approvers/JLL",
        name: "Approvers JLL",
        component: () => import(/* webpackPrefetch: true */ "@/esign/pages/ESignApproversManagement.vue"),
        meta: { auth: true, role: 'ADMIN,R_ESIGN_ADMIN' }
    },
    {
        path: "/admin/Approvers/Tetris",
        name: "Approvers Tetris",
        component: () => import(/* webpackPrefetch: true */ "@/esign/pages/ESignTetrisApproversManagement.vue"),
        meta: { auth: true, role: 'ADMIN,R_TETRIS_ESIGN_ADMIN' }
    },
    {
        path: "/admin/AuthMappings",
        name: "AuthMappings",
        component: () => import(/* webpackPrefetch: true */ "@/authorizationMappings/pages/AuthorizationMappings.vue"),
        meta: { auth: true, role: 'ADMIN' }
    },
    {
        path: "/dueDiligence",
        name: "DueDiligence",
        component: () => import(/* webpackPrefetch: true */ "@/legal/pages/DueDiligence.vue"),
        children: [
            {
                name: 'DueDiligenceComments',
                path: 'Comments/:id',
                component: () => import(/* webpackPrefetch: true */ "@/legal/components/DueDiligenceCommentsModal.vue"),
                meta: { auth: true, role: 'View_LegalArea/LegalClient/ClientList,LEGAL,LEGAL_MNG,LEGAL_ADM,LEGAL_ASS,LEGAL_ASSISTANT_WITH_REOPEN,ADMIN' }
            }
        ],
        meta: { auth: true, role: 'View_LegalArea/LegalClient/ClientList,LEGAL,LEGAL_MNG,LEGAL_ADM,LEGAL_ASS,LEGAL_ASSISTANT_WITH_REOPEN,ADMIN' }
    },
    //{
    //    path: "/informa",
    //    name: "Informa",
    //    component: () => import(/* webpackPrefetch: true */ "@/informa/pages/informa.vue"),
    //    meta: { auth: true, role: 'View_InformaArea/Informa/Index,ADMIN' }
    //},
    {
        path: "/esign",
        name: "ESign",
        component: () => import(/* webpackPrefetch: true */ "@/esign/pages/ESign.vue"),
        props:  route => ({ search: route.query.search }),
        children: [
            {
                name: 'ESignDetail',
                path: 'detail/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/jll/ESignFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index' }
            },
            {
                name: 'ESignEdit',
                path: 'edit/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/jll/ESignFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index' }
            },
            {
                name: 'ESignAdd',
                path: 'add',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/jll/ESignFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index' }
            },
            {
                name: 'ESignComments',
                path: 'Comments/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/jll/ESignCommentsModal.vue"),
                meta: { auth: true, role: 'ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index' }
            }
        ],
        meta: { auth: true, role: 'ADMIN,R_ESIGN_ADMIN,View_ESignArea/ESign/Index' }
    },
    {
        path: "/ESignTetris",
        name: "ESignTetris",
        component: () => import(/* webpackPrefetch: true */ "@/esign/pages/ESignTetris.vue"),
        props:  route => ({ search: route.query.search }),
        children: [
            {
                name: 'ESignTetrisDetail',
                path: 'detail/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/tetris/ESignTetrisFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index' }
            },
            {
                name: 'ESignTetrisEdit',
                path: 'edit/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/tetris/ESignTetrisFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index' }
            },
            {
                name: 'ESignTetrisAdd',
                path: 'add',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/tetris/ESignTetrisFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index' }
            },
            {
                name: 'ESignTetrisComments',
                path: 'Comments/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/tetris/ESignTetrisCommentsModal.vue"),
                meta: { auth: true, role: 'ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index' }
            }
        ],
        meta: { auth: true, role: 'ADMIN,R_TETRIS_ESIGN_ADMIN,View_TetrisESignArea/TetrisESign/Index' }
    },
    {
        path: "/ESignJLLT",
        name: "ESignJLLT",
        component: () => import(/* webpackPrefetch: true */ "@/esign/pages/ESignJLLT.vue"),
        props:  route => ({ search: route.query.search }),
        children: [
            {
                name: 'ESignJLLTDetail',
                path: 'detail/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/jllt/ESignJLLTFormModal.vue"),
                meta: { auth: true, role: 'JLLT_VIEW' }
            },
            {
                name: 'ESignJLLTEdit',
                path: 'edit/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/jllt/ESignJLLTFormModal.vue"),
                meta: { auth: true, role: 'JLLT_VIEW' }
            },
            {
                 name: 'ESIGNJLLTAdd',
                 path: 'add',
                 component: () => import(/* webpackPrefetch: true */ "@/esign/components/jllt/ESignJLLTFormModal.vue"),
                 meta: { auth: true, role: 'JLLT_VIEW' }
             },
            {
                name: 'ESignJLLTComments',
                path: 'Comments/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/jllt/ESignJLLTCommentsModal.vue"),
                meta: { auth: true, role: 'JLLT_VIEW' }
            },
            {
                name: 'ESignJLLTApproval',
                path: 'Approval/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/jllt/VerticalApprovalModal.vue"),
                meta: { auth: true, role: 'JLLT_VIEW' },
                children: [
                    {
                        name: 'ESignJLLTApprovalDetail',
                        path: 'detail',
                        component: () => import(/* webpackPrefetch: true */ "@/esign/components/jllt/ESignJLLTForm.vue"),
                        meta: { auth: true, role: 'JLLT_VIEW' }
                    },
                    {
                        name: 'ESignJLLTApprovalDocuments',
                        path: 'documents',
                        component: () => import(/* webpackPrefetch: true */ "@/shared/components/common/Documents/DocumentsComponent.vue"),
                        meta: { auth: true, role: 'JLLT_VIEW' }
                    },
                    {
                        name: 'ESignJLLTApprovalComments',
                        path: 'comments',
                        component: () => import(/* webpackPrefetch: true */ "@/shared/components/common/Comment/CommentsComponent.vue"),
                        meta: { auth: true, role: 'JLLT_VIEW' }
                    }
                ]
            }
        ],
        meta: { auth: true, role: 'JLLT_VIEW' }
    },
    {
        path: "/ESignDashboard",
        name: "ESignDashboard",
        component: () => import(/* webpackPrefetch: true */ "@/esign/pages/ESignDashboard.vue"),
        meta: { auth: true, role: 'ADMIN,R_TETRIS_ESIGN_ADMIN,R_ESIGN_ADMIN' },
        children: [
            {
                name: 'TetrisDashboard',
                path: 'TetrisDashboard',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/dashboard/tetrisDashboard.vue"),
                meta: { auth: true, role: 'DASHBOARD_TETRIS' }
            },
            {
                name: 'JLLDashboard',
                path: 'JllDashboard',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/dashboard/jllDashboard.vue"),
                meta: { auth: true, role: 'DASHBOARD_JLL' }
            },
            {
                name: 'GlobalDashboard',
                path: 'GlobalDashboard',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/dashboard/globalDashboard.vue"),
                meta: { auth: true, role: 'DASHBOARD_OVERVIEW' }
            }
        ]
    },
    {
        path: "/ESignHR",
        name: "ESignHR",
        component: () => import(/* webpackPrefetch: true */ "@/esign/pages/ESignHR.vue"),
        props:  route => ({ search: route.query.search }),
        meta: { auth: true, role: 'ADMIN,HR_ADMIN' },
        children: [
            {
                name: 'ESignHRDetail',
                path: 'Detail/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/hr/ESignHRFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,HR_ADMIN' }
            },
            {
                name: 'ESignHREdit',
                path: 'Edit/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/hr/ESignHRFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,HR_ADMIN' }
            },
            {
                name: 'ESignHRAdd',
                path: 'Add',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/hr/ESignHRFormModal.vue"),
                meta: { auth: true, role: 'ADMIN,HR_ADMIN' }
            },
            {
                name: 'ESignHRComments',
                path: 'Comments/:id',
                component: () => import(/* webpackPrefetch: true */ "@/esign/components/hr/ESignHRCommentsModal.vue"),
                meta: { auth: true, role: 'ADMIN,HR_ADMIN' }
            },
        ],
    },
    {
        path: "/admin/users",
        name: "Users",
        component: () => import(/* webpackPrefetch: true */ "@/admin/pages/Users.vue"),
        meta: { auth: true, role: 'View_AdminArea/Users/MngUsers,ADMIN,R_ESIGN_ADMIN' }
    },
    {
        path: "/admin/roles",
        name: "Roles",
        component: () => import(/* webpackPrefetch: true */ "@/admin/pages/Roles.vue"),
        meta: { auth: true, role: 'View_AdminArea/Users/MngRoles,ADMIN' }
    },
    {
        path: "/admin/profiles",
        name: "Profiles",
        component: () => import(/* webpackPrefetch: true */ "@/admin/pages/Profiles.vue"),
        meta: { auth: true, role: 'View_AdminArea/Users/MngProfiles,ADMIN' }
    },

    /* FallBack por defecto */
    { path: "*", name: "defaultRedirect", redirect: "/landing" },

    /* Error page no auth */
    { path: "/errAuth", name: "errAuth", component: ErrAuth },
    {
        path: '/healthcheck',
        name: 'HealthCheck',
        meta: { auth: true, role: 'ADMIN' },
        component: () => import(/* webpackChunkName: "healthCheck" */ '@/healthCheck/pages/HealthCheck.vue'),
    },
];

export default routes;
